import DownloadDialog from '@/pages/opinion/components/DownloadCommon/download-dialog';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import React from 'react';

const groupByInfo = [
  { key: 'by_date', value: 'time' },
  { key: 'by_channel', value: 'channel' },
];

const defaultSettings = {
  'Channel Settings': 'Separate by Channel',
  'Time Settings': 'Separate by Time',
};
export default function VideoDownload({
  filter,
  gameInfo,
  visible,
  setVisible,
  defaultSelect,
  type,
  checkboxList,
  showEngagementRate = false,
}: any) {
  const { downloadLegacy, downloading } = useDownloadParams();
  const download = (downloadInfo: any = {}) => {
    const groupBys: Array<string> = [];
    groupByInfo.forEach(({ key, value }) => {
      if (downloadInfo.accumulation?.[key]) {
        groupBys.push(value);
      }
    });

    const newParams = {
      ...filter,
      metrics: downloadInfo.metrics,
      group_bys: groupBys,
    };

    downloadLegacy({
      limit: 150000,
      params: newParams,
      downloadFunc: 'getCommunityVideoBatchTimeLine',
      sheetName: 'Video Chart',
      simpleName: type,
    });
  };

  const defaultMetricsList = [
    { text: 'Video Counts', value: 'counts' },
    { text: 'Engagement', value: 'engagements' },
    ...(showEngagementRate
      ? [{ text: 'Engagement Rate', value: 'engagement_per_view' }]
      : []),
    { text: 'Likes', value: 'likes' },
    { text: 'Comments', value: 'comments' },
    { text: 'Shares', value: 'shares' },
    { text: 'Views', value: 'views' },
  ];

  return (
    <DownloadDialog
      showList={[
        {
          label: 'Metrics',
          type: 'checkbox',
          list: checkboxList || defaultMetricsList,
        },
        {
          label: 'Calculation Method',
          type: 'radioGroup',
          list: [
            {
              label: 'Time Settings',
              list: [
                {
                  text: 'Aggregated',
                  value: 'Aggregated',
                },
                {
                  text: 'Separate by Time',
                  value: 'Separate by Time',
                },
              ],
            },
            {
              label: 'Channel Settings',
              list: [
                {
                  text: 'Aggregated',
                  value: 'Aggregated',
                },
                {
                  text: 'Separate by Channel',
                  value: 'Separate by Channel',
                },
              ],
            },
          ],
        },
      ]}
      visible={visible}
      setVisible={setVisible}
      selectMetric={defaultSelect}
      download={download}
      calculationMethod={defaultSettings}
      confirmLoading={downloading}
      gameInfo={gameInfo}
    ></DownloadDialog>
  );
}
